import { useEffect, useState } from 'react';
import AuthService from 'services/AuthService';
import { UserModel } from 'services/EpdClient';
import createEventEmitter from 'util/createEventEmitter';

const userChangedEmitter = createEventEmitter<UserModel | null>();

export default function useCurrentUser(): UserModel {
  const [user, setUser] = useState(getUser);

  useEffect(() => {
    const unsubscribe = userChangedEmitter.addListener((newUser) => setUser(newUser));
    return () => unsubscribe();
  }, []);

  if (!user) {
    throw new Error('Not authenticated');
  }

  return user;
}

export function useCurrentUserOrNullIfAnonymous(): UserModel | null {
  const [user, setUser] = useState(getUser);

  useEffect(() => {
    const unsubscribe = userChangedEmitter.addListener((newUser) => setUser(newUser));
    return () => unsubscribe();
  }, []);

  return user;
}

export function invalidateCurrentUser() {
  userChangedEmitter.emitEvent(getUser());
}

function getUser() {
  const user = AuthService.getUser();
  if (!user) {
    return null;
  }
  return user;
}
